import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { getIconFromActionType } from '@/modules/auditModule/services/AuditedActionService'

export const auditGridColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('audit.grid.date'),
        field: 'timestamp',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.ipAddress'),
        field: 'ip',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1
    },
    {
        headerName: i18n.tc('audit.grid.user'),
        colId: 'user.id',
        field: 'user.fullNameWithUsername',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.job'),
        field: 'user.job.translatedName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.laboratory'),
        colId: 'laboratory.labName',
        field: 'laboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT,
        flex: 1
    },
    {
        headerName: i18n.tc('audit.grid.entityType'),
        colId: 'entityClassName',
        field: 'entityType.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.entityAction'),
        colId: 'entityActionType',
        field: 'entityActionType.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        cellRenderer: ({ data }: ICellRendererParams) => {
            if (data.entityActionType) {
                let iconClass = getIconFromActionType(data.entityActionType.id)
                return `<i class="far ${iconClass}  main mr-2"></i>${data.entityActionType.name}`
            }
            return ''
        },
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.entityId'),
        colId: 'entityId',
        field: 'entityLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.subentityType'),
        colId: 'subentityClassName',
        field: 'subentityType.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.subentityAction'),
        colId: 'subentityActionType',
        field: 'subentityActionType.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        cellRenderer: ({ data }: ICellRendererParams) => {
            if (data.subentityActionType) {
                let iconClass = getIconFromActionType(data.subentityActionType.id)
                return `<i class="far ${iconClass}  main mr-2"></i>${data.subentityActionType.name}`
            }
            return ''
        },
        filter: false
    },
    {
        headerName: i18n.tc('audit.grid.subentityId'),
        colId: 'subentityId',
        field: 'subentityLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        flex: 1,
        filter: false
    }
]
